import React, { useMemo } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

import { Box, Stack } from '@mui/material';

import { BreadCrumbs } from 'components/Breadcrumbs';
import { ContentLayout } from 'components/Layout';
import { DetailViewTabList } from 'components/TabList';
import { useAuth } from 'lib/auth';
import { paths } from 'routes';

import { STATISTICS_TABS } from '../config';
import { StatisticsFilters } from '../components/StatisticsFilters';
import { StatisticsTab } from '../components/StatisticsTab';
import { resolveFilters } from '../utils/period';

export const Statistics = () => {
  const { account } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = useMemo(() => resolveFilters(searchParams, STATISTICS_TABS), [searchParams]);

  if (!account.super_admin) {
    return <Navigate to={paths.homepage} replace />;
  }

  const updateParams = (changes) => {
    const params = new URLSearchParams(searchParams);
    Object.entries(changes).forEach(([key, value]) => {
      if (value === null || value === undefined) params.delete(key);
      else params.set(key, value);
    });
    setSearchParams(params, { replace: true });
  };

  const currentTab = STATISTICS_TABS.find((tab) => tab.value === filters.tab);

  return (
    <ContentLayout title="Statistics">
      <Stack height={1}>
        <Stack>
          <BreadCrumbs items={[{ name: '', to: '' }, { name: 'Statistics' }]} />
        </Stack>

        <Box sx={{ height: 16, backgroundColor: 'background.paper' }} />

        <DetailViewTabList
          value={filters.tab}
          onChange={(_, tab) => updateParams({ tab })}
          tabs={STATISTICS_TABS.map(({ value, label }) => ({ value, label }))}
        />

        <Stack
          px={4}
          py={2}
          gap={3}
          bgcolor="background.paper"
          borderTop="1px solid"
          borderColor="border.main"
          height="100%"
        >
          <StatisticsFilters filters={filters} onChange={updateParams} showUnique={currentTab.supportsUnique} />
          <StatisticsTab key={currentTab.value} tab={currentTab} filters={filters} />
        </Stack>
      </Stack>
    </ContentLayout>
  );
};
